import React from 'react';
import { isStagingSite } from 'volto-dlr/helpers/context';

const StagingBanner = () => {
  return isStagingSite() ? <div className="staging-banner">STAGING</div> : '';
};

export default StagingBanner;
